/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { LanguageProficiency } from '../enums/language-proficiency';
import { LanguageSkill } from '../enums/language-skill';
import { LanguageEntity } from './language-entity';
import { OpportunityEntity } from './opportunity-entity';
export class OpportunityLanguageEntity extends Entity {
  createdAt: string | null = null;
  id: string = '';
  language: LanguageEntity | null = null;
  languageId: string | null = null;
  opportunity: OpportunityEntity | null = null;
  opportunityId: string | null = null;
  requiredLanguageProficiency: LanguageProficiency | null = null;
  requiredLanguageSkill: LanguageSkill | null = null;
  updatedAt: string | null = null;
  static override key = 'OpportunityLanguage';
  static override get schema() {
    return {
      language: LanguageEntity,
      opportunity: OpportunityEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'OpportunityLanguage' in input
    ) {
      const { OpportunityLanguage: wrapped, ...rest } = input as {
        OpportunityLanguage: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}